import { IconButton, Stack, Typography } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';
import React from 'react'

export default function ModalHeader({label, onClose}) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className="sticky top-[0] !bg-[#ffffff] z-[9] h-[56px]"
      style={{ paddingLeft: '24px', paddingRight: '24px' }}
    >
      <div className="flex">
        <Typography color="#14285A" className="fw-medium fs-14 ff-Roboto !uppercase">{label}</Typography>
      </div>
      <div>
        <IconButton onClick={() => onClose(false)}>
          <ClearIcon style={{ transform: 'scale(1)', color: '#14285A' }} />
        </IconButton>
      </div>
    </Stack>
  )
}
